import { render, staticRenderFns } from "./franchisee-detail.vue?vue&type=template&id=6043c514&scoped=true&"
import script from "./franchisee-detail.vue?vue&type=script&lang=js&"
export * from "./franchisee-detail.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-detail.vue?vue&type=style&index=0&id=6043c514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043c514",
  null
  
)

export default component.exports